import React from 'react';
import {DOMAIN_PROPERTIES} from "../constants";

export default props => {
 
    return <img alt="Logo" src={DOMAIN_PROPERTIES[window.location.host][props.logo || 'logo']} {...props} />;
};

